import { CopyAll } from "@mui/icons-material";
import RegularButton from "components/CustomButtons/Button";
import { makeDirection } from "helpers/makeDirection";
import { validateObject } from "helpers/validateObject";
import { useCopyText } from "hooks/useCopyText";
import React from "react";

export const CopyOrderDetailsButton = ({ order }) => {
  const {
    customer, type, subtype, created, date,
    schedule, address, total, observations,
  } = order;
  const { start, end } = (validateObject(schedule) && schedule) || {};

  const textToCopy = [
    `Cliente: ${customer}.`,
    `Tipo: ${type}.`,
    `Subtipo: ${subtype}.`,
    `Fecha de Creación: ${created}.`,
    `Fecha de Entrega: ${date}.`,
    `Horario: ${start} - ${end}.`,
    `Dirección: ${makeDirection(address)}.`,
    `Total: ${total}.`,
    `Observaciones: ${observations}.`,
  ].join("\n");

  const copyToClipboard = useCopyText(textToCopy);

  return (
    <RegularButton justIcon round color="info" onClick={copyToClipboard} tooltip="Copiar Información">
      <CopyAll />
    </RegularButton>
  );
};
